import * as React from 'react';

function SvgSquare1(props: React.SVGProps<SVGSVGElement>) {
    return (
        <svg
            width="1em"
            height="1em"
            viewBox="0 0 40 40"
            fill="none"
            {...props}
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M10 13a3 3 0 013-3h14a3 3 0 013 3v14a3 3 0 01-3 3H13a3 3 0 01-3-3V13zm3-1a1 1 0 00-1 1v14a1 1 0 001 1h14a1 1 0 001-1V13a1 1 0 00-1-1H13z"
                fill="#8492A6"
            />
        </svg>
    );
}

export default SvgSquare1;
